module.exports = __webpack_public_path__ + "static/media/about5.14712970.jpg";